module.exports = __webpack_public_path__ + "img/007.1d07167a.png";